import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Plus, Trash2, UserCheck } from "lucide-react";
import { api } from "../../lib/api";

export function EventStaffPage() {
    const { id } = useParams();
    const { t } = useTranslation();
    const [list, setList] = useState([]);
    const [email, setEmail] = useState("");

    const load = async () => {
        const { data } = await api.get(`/api/admin/events/${id}/staff`);
        setList(data || []);
    };
    useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    const add = async () => {
        if (!email) return;
        try {
            await api.post(`/api/admin/events/${id}/staff`, { email });
            setEmail("");
            load();
            toast.success(t("common.success"));
        } catch (e) {
            toast.error(e?.response?.data?.detail || t("common.error"));
        }
    };

    const remove = async (staffId) => {
        await api.delete(`/api/admin/events/${id}/staff/${staffId}`);
        load();
    };

    return (
        <div data-testid="event-staff-page" className="space-y-4">
            <div className="bento-card p-5">
                <div className="flex flex-col sm:flex-row gap-2">
                    <input data-testid="staff-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("organizer.add_staff")} className="input-modern flex-1" />
                    <button data-testid="add-staff-btn" onClick={add} className="btn-primary inline-flex items-center gap-2">
                        <Plus className="h-4 w-4" />
                        {t("admin.add")}
                    </button>
                </div>
            </div>

            <div className="bento-card overflow-hidden">
                {list.length === 0 ? (
                    <div className="p-8 text-center text-muted-foreground">
                        <UserCheck className="h-8 w-8 mx-auto mb-2 opacity-40" />
                        No staff members yet.
                    </div>
                ) : (
                    <div className="divide-y divide-border">
                        {list.map((s) => (
                            <div key={s.id} data-testid={`staff-${s.id}`} className="flex items-center justify-between p-4">
                                <div>
                                    <div className="font-semibold">{s.user?.first_name} {s.user?.last_name}</div>
                                    <div className="text-sm text-muted-foreground">{s.user?.email}</div>
                                </div>
                                <button data-testid={`remove-staff-${s.id}`} onClick={() => remove(s.id)} className="p-2 text-destructive hover:bg-destructive/10 rounded-lg">
                                    <Trash2 className="h-4 w-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
